import { render, staticRenderFns } from "./CompensationStatusSelector.vue?vue&type=template&id=18c917b4&scoped=true&"
import script from "./CompensationStatusSelector.vue?vue&type=script&lang=js&"
export * from "./CompensationStatusSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c917b4",
  null
  
)

export default component.exports